import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AccountApplicationModel } from 'src/app/models';
import { CameraDialogComponent } from '../camera-dialog/camera-dialog.component';


@Component({
  selector: 'app-document-attachment',
  templateUrl: './document-attachment.component.html',
  styleUrls: ['./document-attachment.component.css']
})
export class DocumentAttachmentComponent implements OnInit {
  @Input() accountAppModel: AccountApplicationModel;
  @Input() checklistArrayName: string = "TmxLoanApplicationChecklist";
  @Input() productChecklistIdName: string = "LoanProductChecklistId";
  public Checklists: any[] =
    [
    { 'id': '1', 'url': 'attachment', 'uploaded': false, 'Name': 'Salaried: Income / Salary Proof  (not older than 3 Months) OR Self Employed: (6 Months Bank Statement)', 'group': 'required','required': true }];
  displayedColumns: string[] = ['Document Type', 'Attachment', 'Action'];
  validFormats: any[] = ['jpg', 'png', 'gif', 'jpeg', 'pdf', 'xls', 'xlsx', 'doc', 'docx'];
  imageSrc: any;
  fileURL: any;
  appChecklist: any;
  dataSource = this.Checklists;

  constructor(public toastr: ToastrService,private dialog: MatDialog) {
    //this.accountAppModel['Checklists'] = this.Checklists;

  }
  displayPhoto(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        this.imageSrc = e.target['result'];
      });

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
//some changes
  ngOnInit() {
    if (this.accountAppModel[this.checklistArrayName]) {

      this.appChecklist = this.accountAppModel[this.checklistArrayName];

      for (let i = 0; i < this.Checklists.length; i++) {

        var matchingChecklistItem = this.appChecklist.find(x => x[this.productChecklistIdName] == this.Checklists[i].id);
        if (matchingChecklistItem) {
          //this.Checklists[i].url = matchingChecklistItem.AttachmentURL;
          this.Checklists[i].url = setUrlFromAttachment(matchingChecklistItem.AttachmentURL);
          this.Checklists[i].uploaded = true;
        }
      }

    }
    function setUrlFromAttachment(attachmentText) {
      if (attachmentText) {
        let extension = attachmentText.slice(attachmentText.lastIndexOf('.') + 1);
        extension = extension == 'doc' ? 'docx' : extension;
        extension = extension == 'jpg' ? 'jpeg' : extension;
        if (['png', 'docx', 'pdf','jpeg'].includes(extension) ){
          return `assets/images/${extension}.png`;
        }
      }
      return "assets/images/attachment.png";
    }

  }

  async onChange(event: any, element: any) {

    if (event.target.files && event.target.files[0]) {
      if (!this.validateFile(event.target.files[0])) {
        return;
      }
      var fileInput = event.target.files[0];
      if(["image/jpeg","image/png","image/jpg"].includes(fileInput.type)){
        fileInput = await compressFile(fileInput);
      }
      var reader = new FileReader();
      reader.readAsDataURL(fileInput); // read file as data url
      reader.onload = ((e) => {
        element.Attachment = reader.result;
        this.setChecklistAndMimeType(element);
      });

      element.url = event.target.files[0].type + ".png";
      element.url = "assets/images/" + element.url.slice(element.url.indexOf('/') + 1);
      if (element.url.indexOf("word") !== -1) {
        element.url = "assets/images/docx.png";
      }
      else if (!((element.url.indexOf("jpeg") !== -1) || (element.url.indexOf("png") !== -1) || (element.url.indexOf("pdf") !== -1))) {
        element.url = "assets/images/attachment.png";
      }
    }

    element.uploaded = true;

    async function compressFile(fileInput){
      console.log('originalFile instanceof Blob', fileInput instanceof Blob); // true
      console.log(`originalFile size ${fileInput.size / 1024 / 1024} MB`);

      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 768,
        useWebWorker: false
      }
      try {
        const compressedFile = await imageCompression(fileInput, options);
        console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        return compressedFile;

      } catch (error) {
        console.log(error);
      }
    }
  }
  setChecklistAndMimeType(element){
    element.MimeType = '';
        if (element.Attachment.includes('data:image/jpeg;base64') || element.Attachment.includes('data:image/png;base64')) {
          element.MimeType = 'image\/png';
        }
        else if (element.Attachment.includes('data:application/pdf;base64')) {
          element.MimeType = 'application\/pdf';
        }
        else if (element.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
          element.MimeType = 'application\/xlsx';
        }
        else if (element.Attachment.includes('data:application/msword;base64') || element.Attachment.includes('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64')) {
          element.MimeType = "application/msword";
        }
        else if (element.Attachment.includes('data:image/tiff;base64')) {
          element.MimeType = "image/tiff";
        }
        this.mappingToChecklistTable(element);
  }
  mappingToChecklistTable(element) {
    if (!this.accountAppModel[this.checklistArrayName]) {
      this.accountAppModel[this.checklistArrayName] = [];
    }
    if (this.accountAppModel[this.checklistArrayName] && this.accountAppModel[this.checklistArrayName].length > 0) {
      var checklistObj = this.accountAppModel[this.checklistArrayName].filter(x => x[this.productChecklistIdName] == element.id)[0];
      if (checklistObj) {
        //checklistObj['Attachment'] = element.Attachment.replace(/^data:image\/(png|jpg|jpeg|pdf|tiff|msword);base64,/, '').replace(/^data:application\/(pdf|msword);base64,/, '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
        let metadataIdx = element.Attachment.indexOf(';base64,')
        checklistObj['Attachment'] = element.Attachment.substring(metadataIdx + 8);
        checklistObj[this.productChecklistIdName] = element.id;
        checklistObj.MimeType = element.MimeType;
        checklistObj['uploaded'] =true;
        // checklistObj.FileData= checklistObj.Attachment;
        // checklistObj.ImageData= checklistObj['Attachment'] ;
        this.accountAppModel[this.checklistArrayName].filter(x => x[this.productChecklistIdName] == element.id)[0] = checklistObj;
      }
      else {
        var newChecklist = {};
        //newChecklist['Attachment'] = element.Attachment.replace(/^data:image\/(png|jpg|jpeg|pdf|tiff|msword);base64,/, '').replace(/^data:application\/(pdf|msword);base64,/, '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
        let metadataIdx = element.Attachment.indexOf(';base64,')
        newChecklist['Attachment'] = element.Attachment.substring(metadataIdx + 8);
        newChecklist['MimeType'] = element.MimeType;
        newChecklist[this.productChecklistIdName] = element.id;
        newChecklist['uploaded'] =true;
        // newChecklist['FileData']= newChecklist['Attachment'];
        // newChecklist['ImageData']= newChecklist['Attachment'];
        this.accountAppModel[this.checklistArrayName].push(newChecklist);
      }
    }
    else {
      var newChecklist = {};
      //newChecklist['Attachment'] = element.Attachment.replace(/^data:image\/(png|jpg|jpeg|pdf|tiff|msword);base64,/, '').replace(/^data:application\/(pdf|msword);base64,/, '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
      let metadataIdx = element.Attachment.indexOf(';base64,')
      newChecklist['Attachment'] = element.Attachment.substring(metadataIdx + 8);
      newChecklist['MimeType'] = element.MimeType;
      newChecklist[this.productChecklistIdName] = element.id;
      // newChecklist['FileData']= newChecklist['Attachment'];
      // newChecklist['ImageData']=  newChecklist['Attachment']
      newChecklist['uploaded'] =true;
      this.accountAppModel[this.checklistArrayName].push(newChecklist);
    }

  }
  onDelete(event: any, element: any) {
    element.uploaded = false;
    if (this.accountAppModel[this.checklistArrayName]) {
      for (let index = 0; index < this.accountAppModel[this.checklistArrayName].length; index++) {
        if (this.accountAppModel[this.checklistArrayName][index][this.productChecklistIdName] == element.id) {
          this.accountAppModel[this.checklistArrayName][index].Attachment = "";
          this.accountAppModel[this.checklistArrayName][index].AttachmentURL = "";
          this.accountAppModel[this.checklistArrayName][index].uploaded = false;
        }

      }
      //this.accountAppModel[this.checklistArrayName] = this.accountAppModel[this.checklistArrayName].filter(x => x.LoanProductChecklistId != element.id);
    }
  }

  openCamera(event: any, element: any){
    let dialogRef = this.dialog.open(CameraDialogComponent, {
      panelClass: 'full-screen-modal',
      data: {
        title: 'Application Saved',
        message: 'Your application saved with application number <b>AA0011992</b>',
        type: 'success'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        element.Attachment = result.imageAsDataUrl;
        element.url = "assets/images/jpeg.png";
        element.uploaded = true;
        this.setChecklistAndMimeType(element);
      }

    });
  }

  validateFile(file) {
    if (file) {
      if (this.validFormats.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()) < 0) {
        this.toastr.error('File format is not supported.');
        return false;
      }
      if (file.size > (2 * 1024 * 1024)) {
        this.toastr.error('File size must be less than 2MB.');
        return false;
      }

      // var notAllowedExtensions = ['.pdf','.xlsx','xls'];
      // if (!(file.name.includes('.pdf') || file.name.includes('.xlsx') || file.name.includes('.xls'))) {
      //   //watermark([file])
      //   //.image(watermark.text.lowerRight($scope.watermark.text, $scope.watermark.font, $scope.watermark.color, $scope.watermark.opacity))
      //   //.then(function (img) {
      //   //	$scope.updateImage(img.src);
      //   //});
      // }
      // else {
      //   // watermark([file]).blob().then(function(res){
      //   // 	console.log(res);
      //   // 	})
      //   this.getBase64(file, element);
      // }
    }
    return true;
  }

  getBase64(file, element) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setTimeout(() => {
        element.fileURL = reader.result;
      });
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

}
